module.exports = __webpack_public_path__ + "img/cvv.e4e1fe02.svg";